<template>
  <el-container>
    <el-main>
      <h3 class="heading">Buy</h3>
      <el-card v-if="item">
        <FlatDealForm
          v-if="item"
          v-model="form"
          :loading="loading"
          :flat-deal="item"
          @submit="onSubmit"
        >
          <FlatDealInfo :id="id" v-model="item" :disabled="true" />
        </FlatDealForm>
      </el-card>
      <LoadingBlock :loading="fetchingFlatDeal" />
      <div
        v-if="!fetchingFlatDeal && !item"
        class="el-alert el-alert--warning is-light"
      >
        <h4>
          Unfortunately, this deal was sold or deactivated by the publisher, but
          you can find more deals in
          <router-link to="/direct_deals">
            <el-button type="text"> the deal buffet </el-button>
          </router-link>
        </h4>
      </div>
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { ref, defineComponent, watch, computed, onMounted } from 'vue'

import FlatDealInfo from '../components/FlatDealInfo.vue'
import FlatDealForm from '../components/FlatDealForm.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import { useCountriesStore } from '@/store/modules/countries'

import { IFlatDealBuyForm } from '@/apps/traforama/interfaces/flatDeals'
import useRouter from '@/hooks/useRouter'
import { safeSubmitProcessing } from '@/utils/helpers'
import { ElMessage } from 'element-plus'
import { useFlatDealsStore } from '@/apps/traforama/store/flatDeals'
import useValidation from '@/hooks/useValidation'
import { FlatDealValidationErrorsKey, VideoSource } from '@/api/types'

export default defineComponent({
  name: 'BuyFlatDeal',
  components: {
    FlatDealInfo,
    FlatDealForm,
    LoadingBlock
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  setup(props, _context) {
    useCountriesStore().GetItems()
    const flatDealsStore = useFlatDealsStore()

    const item = computed(() => flatDealsStore.current)
    const fetchingFlatDeal = computed(
      () => flatDealsStore.itemsLoading[props.id]
    )
    const loading = ref(false)

    const form = ref({
      deal_name: '',
      icon: '',
      image: '',
      code: '',
      impression_url: '',
      description: '',
      title: '',
      link_url: '',
      skip_offset: 5,
      vast_tag: '',
      video_source: VideoSource.Url,
      remote_url: '',
      video: ''
    })

    watch(
      () => props.id,
      (newVal) => {
        flatDealsStore.FetchItem(newVal)
      }
    )

    onMounted(() => flatDealsStore.FetchItem(props.id))

    const { router } = useRouter()

    const { provideValidation, setValidationErrors } = useValidation(
      FlatDealValidationErrorsKey
    )
    const errors = provideValidation()

    const onSuccess = async () => {
      await router.push(`/direct_deals/`)
      ElMessage.success({
        message: 'Campaign has been created',
        type: 'success'
      })
    }

    const onSubmit = async (flatDealForm: IFlatDealBuyForm) => {
      if (!item.value || loading.value) return

      flatDealForm.pub_campaign_id = item.value.campaign_id
      await safeSubmitProcessing(
        loading,
        () => flatDealsStore.BuyItem(flatDealForm as IFlatDealBuyForm),
        () => onSuccess(),
        (err) => setValidationErrors(err, errors)
      )
    }

    return { item, loading, fetchingFlatDeal, form, onSubmit }
  }
})
</script>
<style lang="scss" scoped>
.filter-container {
  padding-bottom: 0;
  .el-card__body {
    padding-bottom: 0;
  }
}
.padding-5 {
  padding-top: 5px;
  padding-bottom: 5px;
}
:deep(.el-card.is-always-shadow) {
  box-shadow: none;
}
</style>
